import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
    ContentWrapper,
    HeaderContainer,
    Title,
    ProfilePageContainer,
    TemplateList,
} from "./TemplatesPage.styles";
import Sidebar from "../../components/Sidebar";
import { fetchDocumentTemplates } from "../../services/documentService/documentService";
import { DocumentTemplate } from "../../services/documentService/documentService.types";
import DocumentCard from "../../components/DocumentCard/DocumentCard";

import { useNotify } from "context/NotificationContext";
const TemplatesPage: React.FC = () => {
    const [templates, setTemplates] = useState<DocumentTemplate[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const toast = useNotify();
    const navigate = useNavigate();

    useEffect(() => {
        const loadTemplates = async () => {
            try {
                setLoading(true);
                const fetchedTemplates = await fetchDocumentTemplates();
                const sortedTemplates = fetchedTemplates.sort((a, b) => {
                    return Number(b.is_subscribed) - Number(a.is_subscribed);
                });
                setTemplates(sortedTemplates);
            } catch (err) {
                setError("Ошибка при загрузке шаблонов");
            } finally {
                setLoading(false);
            }
        };

        loadTemplates();
    }, []);

    const handleCardClick = (template: DocumentTemplate) => {
        if (template.availability_status === "processing") {
            toast.show({
                severity: "warn",
                summary: "Документ на технической обработке",
                detail: "Документ временно недоступен. Он появится после завершения технической обработки.",
                life: 4500,
            });
            return;
        }
        if (!template.is_subscribed) {
            toast.show({
                severity: "warn",
                summary: "Документ недоступен",
                detail: "Этот документ не входит в действующий тариф.",
                life: 4500,
            });
            return;
        }
        navigate(`/documents/${template.id}/versions?templateName=${template.title}`); 
    };

    return (
        <ProfilePageContainer>
            <Sidebar />
            <ContentWrapper>
                <HeaderContainer>
                    <Title>Шаблоны документов</Title>
                </HeaderContainer>
                {loading && <p>Загрузка...</p>}
                {error && <p>{error}</p>}
                {!loading && !error && (
                    <TemplateList>
                        {templates.map((template) => (
                            <DocumentCard
                                key={template.id}
                                title={template.title}
                                templateId={template.id}
                                isSubscribed={template.is_subscribed}
                                availabilityStatus={template.availability_status}
                                onClick={() => handleCardClick(template)}
                            />
                        ))}
                    </TemplateList>
                )}
            </ContentWrapper>
        </ProfilePageContainer>
    );
};

export default TemplatesPage;
